export default {
  weeks: [
    {
      weekNo: "1",
      name: "星期一",
    },
    {
      weekNo: "2",
      name: "星期二",
    },
    {
      weekNo: "3",
      name: "星期三",
    },
    {
      weekNo: "4",
      name: "星期四",
    },
    {
      weekNo: "5",
      name: "星期五",
    },
    {
      weekNo: "6",
      name: "星期六",
    },
    {
      weekNo: "7",
      name: "星期日",
    },
    {
      weekNo: "8",
      name: "调班日",
    },
    {
      weekNo: "0",
      name: "节假日",
    },
  ],
  numType:{
    average:"动态号源",
    dynamic:"平均号源"
  },
  clinicType:{
    outpatient:"门诊",
    inpatient:"住院"
  },
  JcBillStatusOption: [
    {
      text: "未预约",
      value: "no",
      color: "#a1a3a6",
    },
    {
      text: "已预约",
      value: "ok",
      color: "#38ACEC",
    },
    {
      text: "已取消",
      value: "cancel",
      color: "#ffd400",
    },
    {
      text: "已签到",
      value: "take",
      color: "#00FF00",
    },
    {
      text: "已停诊",
      value: "stop",
      color: "#786D5F",
    },
    {
      text: "爽约",
      value: "undo",
      color: "#FF2400",
    },
  ],
  paidStatusOption: [
    {
      text: "未支付",
      value: "unpaid",
      color: "#E6A23C",
    },
    {
      text: "已支付",
      value: "paid",
      color: "#67C23A",
    },
    {
      text: "已退费",
      value: "refund",
      color: "#F56C6C",
    },
  ],
};
